<template>
  <a-tabs :default-active-key="1" tab-position="left">
    <a-tab-pane :key="1" tab="进行中流程" style="margin-left: -24px;">
      <runtime-modal ref="RuntimeModal"></runtime-modal>
    </a-tab-pane>
    <a-tab-pane :key="2" tab="终了流程" style="margin-left: -24px;">
      <history-modal ref="HistoryModal"></history-modal>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'
import RuntimeModal from './modules/RuntimeModal'
import HistoryModal from './modules/HistoryModal'

export default {
  name: 'SolvedManage',
  components: {
    RuntimeModal,
    HistoryModal
  },
  data() {
    return {
      description: '任務管理画面',
      // スタート条件
      startParam: {},
      // 検索条件
      queryParam: {},
      // テーブルタイトル
      columns: [],
      url: {}
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.ant-tabs {
  :global(.ant-tabs-left-bar) {
    padding: 10px 0;
  }
}

// /deep/ .ant-table-row-cell-ellipsis {
//   white-space: unset;
// }
</style>
